import { render } from "./ActionABTest.vue?vue&type=template&id=5b831f93&scoped=true"
import script from "./ActionABTest.vue?vue&type=script&lang=ts"
export * from "./ActionABTest.vue?vue&type=script&lang=ts"

import "./ActionABTest.vue?vue&type=style&index=0&id=5b831f93&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b831f93"

export default script